import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgFilterOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 32 34"
    stroke="#17181A"
    strokeLinejoin="round"
    fillRule="evenodd"
    clipRule="evenodd"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="m2.667 5.96 10.62 9.772v13.27l6.007-2.342V15.732l10.04-9.772V2.331H2.666v3.63Z" />
  </svg>
);
const Memo = memo(SvgFilterOutlined);
export default Memo;
